var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"d-flex flex-row justify-content-center justify-content-xl-between align-items-center py-5 px-3 px-xl-0",class:!_vm.wide ? 'slide--vertical' : ''},[_c('img',{staticClass:"mb-3",attrs:{"src":require(`@/assets/img/${_vm.image}.png`),"alt":_vm.image}}),_c('h5',{staticClass:"ml-xl-5"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }